module.exports = __webpack_public_path__ + "img/Products_Desktop_01.1939ca01.jpg";